const CONSTANTS = {
  defaultUserForm: () => {
    return {
      username: null,
      code: null,
      role: "ROLE_CLIENT",
      fullName: null,
      phone: null,
      email: null,
      address: null,
      password: null,
      repeatPassword: null,
      withdrawalAuto: false,
      withdrawalPercent: null,
      paymentChargesPercent: null
    };
  },
  defaultAppForm: () => {
    return {
      name: null,
      shortName: null,
      description: null,
      user: null,
      email: null
    };
  },
  defaultProvisionForm: () => {
    return {
      amount: null,
      operation: null,
      comment: null
    };
  },
  defaultProfileForm: () => {
    return {
      fullName: "",
      phone: null,
      address: null,
      oldPassword: null,
      password: null,
      email: null
    };
  },
  defaultPaymentStat: () => {
    return {
      success: 0,
      cancel: 0,
      amount: 0
    }
  },
  defaultUserSetting: () => {
    return {
      transfer: {
        amount_min: null,
        amount_max: null,
        active: false,
        daily_withdrawal_limit: null,
      },
      payment: {
        amount_min: null,
        amount_max: null
      }
    }
  },
  defaultTransferSetting: () => {
    return {
      amount_min: 5,
      amount_max: null
    }
  },
  defaultPaymentSetting: () => {
    return {
      amount_min: 5,
      amount_max: null
    }
  },
};

export default CONSTANTS;
